import { styled } from '@mui/material'
import { tokens } from 'ComponentLibrary'
import { ViewSwitchItem } from './ViewSwitchItem'
import { ReactNode } from 'react'

type ViewSwitchItemProps = {
    label: string
    value: string
    leftIcon?: ReactNode
    rightIcon?: ReactNode
}

type ViewSwitchProps = {
    items: ViewSwitchItemProps[]
    value: string
    onClick: (newViewSwitch: string) => void
}

export function ViewSwitch({ items, onClick, value }: ViewSwitchProps) {
    return (
        <ViewSwitchContainer>
            {items.map((item) => (
                <ViewSwitchItem
                    key={item.label}
                    leftIcon={item.leftIcon}
                    rightIcon={item.rightIcon}
                    label={item.label}
                    selected={value === item.value}
                    value={item.value}
                    onClick={() => onClick(item.value)}
                />
            ))}
        </ViewSwitchContainer>
    )
}

const ViewSwitchContainer = styled('div')({
    display: 'flex',
    borderRadius: tokens.SizingCornerS,
    backgroundColor: tokens.ColorSurfaceDefault,
    border: `${tokens.SizingBorderS} solid ${tokens.ColorBorderDefault}`,
})
